module.exports = __webpack_public_path__ + "static/media/pergunte-ao-edital.b3a7f7df.svg";